module.exports = __webpack_public_path__ + "media/images/features/draft/icon-point-01-7bca72bafd9bf3de03066dc9e89f537e.svg";